import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { BodyText, BodyTextProps } from '../../typography';
import { theme } from '../../../theme';
import { SvgComponent } from '../../../assets';

export type ActionIconFieldProps = {
  icon?: SvgComponent;
  contentComponent?: React.ComponentType<BodyTextProps>;
  title?: string;
};

const IconFieldContainer = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;

  > * + * {
    margin-left: ${theme.spacings[1].rem};
  }
`;

const TextContent = styled(BodyText).attrs({ size: { xs: 'xs', sm: 'sm' } })``;

export const ActionIconField: React.FC<
  PropsWithChildren<ActionIconFieldProps>
> = ({
  icon: Icon,
  children,
  contentComponent: Content = TextContent,
  ...props
}) => {
  return (
    <IconFieldContainer {...props}>
      {Icon && <Icon />} <Content>{children}</Content>
    </IconFieldContainer>
  );
};
